module.exports = __webpack_public_path__ + "static/media/SeaLighthouse-sunset.4e9fe9cc.svg";